import React, { useEffect } from "react";
import { useState } from "react";
import * as shopifyCurrency from "@shopify/theme-currency";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";

const useProduct = (target) => {
  const [product, setProduct] = useState({
    limit: 5,
    charms: [],
    main: {
      id: null,
      price: 0,
      sku: "",
      available: false,
    },
  });

  const getCharm = (id) => {
    return product.charms.find((variant) => variant.id === id);
  };

  useEffect(() => {
    const element = document.querySelector(target);
    if (element) {
      setProduct(JSON.parse(element.innerHTML));
    }
  }, []);

  return {
    product,
    getCharm,
  };
};

const useCurrency = () => {
  const [currency, setCurrency] = useState(Cookies.get("currency") ?? "GBP");

  useEffect(() => {
    const element = document.querySelector(".currency-picker");
    if (element) {
      element.addEventListener("change", () => {
        setCurrency(Cookies.get("currency"));
      });
    }
    return () => {
      if (element) {
        element.removeEventListener("change", () => {
          setCurrency(Cookies.get("currency"));
        });
      }
    };
  }, []);

  return {
    currency,
  };
};

export const ProductFormCharms = () => {
  const { product, getCharm } = useProduct('[data-json="ProductFormCharms"]');
  const { currency } = useCurrency();
  const [selected, setSelected] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [payload, setPayload] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const selectedVariantsPayload = selected.map((id) => {
      const variant = getCharm(id);
      return variant;
    });
    const payloadData = [product.main, ...selectedVariantsPayload];
    setPayload(payloadData);
    setTotalPrice(payloadData.reduce((acc, item) => acc + item.price, 0));
  }, [product, selected]);

  const handleAddToCart = () => {
    setIsSubmitting(true);
    const uuid = uuidv4();
    const payloadData = payload.map((item) => {
      return {
        id: item.id,
        quantity: 1,
        properties: {
          ...item.properties,
          _bundle_uuid: uuid,
        },
      };
    });

    console.log("payload", payloadData);

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: payloadData,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setSelected([]);
        window.location.href = "/cart";
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.error("Error:", error);
      });
  };

  return (
    <div className="pb-4">
      <div className="pb-4">
        <p id="product-price" className="pb-2">
          <span className="product-price">
            <span
              className="react-money"
              dangerouslySetInnerHTML={{
                __html: Currency.convertOne(totalPrice, "GBP", currency),
              }}
            />
          </span>
        </p>
        <p id="product-quantity" className="mt-4 lg:mt-0">
          {selected.length} {selected.length === 1 ? "charm" : "charms"}
        </p>
        <p id="product-sku" className="mt-4 lg:mt-0 text-gray-500">
          SKU: {payload.map((item) => item.sku).join(", ")}
        </p>
      </div>

      {/* <div>
        <pre>{JSON.stringify(selected, null, 2)}</pre>
      </div> */}

      <div>
        <p className="mb-2 uppercase font-semibold tracking-25">
          Customise with up to {product.limit} charms
        </p>
        <ul className="grid w-full gap-3 grid-cols-3 lg:grid-cols-4">
          {product.charms.map((item) => {
            if (item.title === "Main") return null;
            return (
              <li key={item.id}>
                <input
                  type="checkbox"
                  id={`option-${item.id}`}
                  name={`option-${item.id}`}
                  checked={selected.includes(item.id)}
                  value={item.id}
                  className="!hidden peer"
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelected([...selected, item.id]);
                    } else {
                      setSelected(selected.filter((id) => id !== item.id));
                    }
                  }}
                  disabled={
                    (!selected.includes(item.id) &&
                      selected.length >= product.limit) ||
                    !item.available
                  }
                />
                <label
                  htmlFor={`option-${item.id}`}
                  className="
                    inline-flex items-center justify-between w-full h-full p-1
                    text-gray-700 bg-white border border-gray-200 cursor-pointer

                    peer-checked:border-black peer-checked:text-gray-600

                    hover:border-black
                    
                    peer-disabled:opacity-50 peer-disabled:cursor-not-allowed"
                >
                  <div className="block relative w-full h-full text-center">
                    {selected.includes(item.id) && (
                      <div className="absolute top-0 right-0">
                        <i className="fa fa-check-circle text-lg/none"></i>
                      </div>
                    )}
                    <div className="flex justify-center mb-2">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="object-contain h-20"
                      />
                    </div>
                    <div className="w-full pb-1 uppercase font-semibold tracking-25">
                      {item.title}
                    </div>
                    <div className="w-full">
                      <span
                        className="react-money text-xs tracking-25"
                        dangerouslySetInnerHTML={{
                          __html: Currency.convertOne(
                            item.price,
                            "GBP",
                            currency
                          ),
                        }}
                      />
                    </div>
                    {/* <div className="w-full text-xs">
                      {item.available ? (
                        <div className="text-green-600">in stock</div>
                      ) : (
                        <div className="text-red-600">sold out</div>
                      )}
                    </div> */}
                  </div>
                </label>
              </li>
            );
          })}
        </ul>
      </div>

      <button
        className="add add-to-cart-btn !mt-4 disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={handleAddToCart}
        disabled={isSubmitting || product.main.available === false}
      >
        <span>{product.main.available ? "Add to Cart" : "Out of stock"}</span>
      </button>
    </div>
  );
};
